export default "__VITE_ASSET__BJTrG8ZX__"